let OptionsRegion = [
    { "label": "Lombardia", "value":'Lombardia' },
    { "label": "Trentino Alto Adige", "value":'Trentino-Alto Adige' },
    { "label": "Veneto", "value":'Veneto' },
    { "label": "Friuli Venezia Giulia", "value":'Friuli-Venezia Giulia' },
    { "label": "Emilia Romagna", "value":'Emilia-Romagna' },
    { "label": "Toscana", "value":'Toscana' },
    { "label": "Umbria", "value":'Umbria' },
    { "label": "Marche", "value":'Marche' },
    { "label": "Abruzzo", "value":'Abruzzo' },
    { "label": "Molise", "value":'Molise' },
    { "label": "Puglia", "value":'Puglia' },
    { "label": "Basilicata", "value":'Basilicata' },
    { "label": "Lazio", "value":'Lazio' },
    { "label": "Campania", "value":'Campania' },
    { "label": "Calabria", "value":'Calabria' },
    { "label": "Sicilia", "value":'Sicilia' },
    { "label": "Val d'Aosta", "value":"Val d'Aosta" },
    { "label": "Piemonte", "value":"Piemonte" },
    { "label": "Liguria", "value":"Liguria" },
    { "label": "Sardegna", "value":"Sardegna" },
]
export default OptionsRegion;